import { MeshStandardMaterial, type Texture } from "three";

export function createPhysicalCardFaceMaterial({
  texture,
  dimmed,
  legal,
  selected,
  focused,
}: {
  readonly texture: Texture;
  readonly dimmed: boolean;
  readonly legal: boolean;
  readonly selected: boolean;
  readonly focused: boolean;
}): MeshStandardMaterial {
  const highlighted = legal || selected || focused;
  return new MeshStandardMaterial({
    map: texture,
    color: dimmed ? "#858585" : "#ffffff",
    emissive: legal ? "#5bc878" : focused ? "#f1cf74" : selected ? "#c79d43" : "#000000",
    emissiveIntensity: legal ? 0.18 : focused ? 0.28 : selected ? 0.14 : 0,
    metalness: 0.03,
    roughness: 0.68,
    transparent: false,
    opacity: 1,
    depthTest: true,
    depthWrite: true,
    toneMapped: !highlighted,
  });
}
